App.filter('timeFormatter', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);
            
            var hours = time.getUTCHours();
            if (hours < 10) {
                hours = '0' + hours;
            }
            var minutes = time.getUTCMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            var all = hours + ':' + minutes;
        }
        return all;
    };
})